import { defineEffect } from '../../../core/effect';

/**
 * **反転召喚成功**（Issue #538）。`flipsummoning` の後、無効にされずに場に出た瞬間。
 *
 * 画面の中央にカードを大きく出して名前を添える（アップのウィンドウ）。
 * **出た場所ではなく画面の中央**なのは、盤の上だと小さくて何が出たか分からないため。
 */
const COLOR = '#9fe8ff';

export default defineEffect({
  situation: 'flipsummoned',
  label: '反転召喚成功',
  color: COLOR,
  sounds: () => [{ at: 0, name: 'effect' }],

  /**
   * **このイベントは `data` が空**（どのカードが出たかを持っていない）。
   * **直前の `summoning` から引く**（設計文書 §3.3）。
   *
   * **窓は `op` では駄目**（Issue #537 で踏んだ）—— core は `summoning` と `summoned` を
   * **別の応答**として出す（実データで op_seq 303 / 305）。召喚はそのフェイズの中で解決するので、
   * `new_phase` / `new_turn` で打ち切る。同じフェイズに 2 回召喚しても**一番近いもの**が取れる。
   */
  opens({ payload, history }) {
    const from = history.last('flipsummoning', { until: ['new_phase', 'new_turn'] });
    const card = from?.payload;
    if (!card?.code && !card?.uid) return null;
    return { ...payload, uid: card.uid, code: card.code, zone: card.zone, player: card.player };
  },

  layers: [
    {
      id: 'back',
      label: '後ろの光',
      part: 'glow',
      at: { screen: [960, 520] },
      props: { color: COLOR, core: 0.1 },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.6 }, { ms: 260, value: 2.6, ease: 'ease_out' }, { ms: 1100, value: 2.8 }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 200, value: 0.8 }, { ms: 1100, value: 0 }] },
      },
    },
    {
      id: 'card',
      label: 'カードのアップ',
      part: 'card',
      parent: 'back',
      props: { code: '{code}', player: '{player}', glow: COLOR, glowW: 8 },
      tf: {
        scale: { keys: [{ ms: 60, value: 0.35 }, { ms: 320, value: 0.62, ease: 'ease_out' }, { ms: 1000, value: 0.6 }] },
        opacity: { keys: [{ ms: 60, value: 0 }, { ms: 220, value: 1 }, { ms: 980, value: 1 }, { ms: 1100, value: 0 }] },
      },
    },
  ],
}, 'flipsummoned_effect.js');
